function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M2.34314 13.6569C-0.781047 10.5327 -0.781047 5.46736 2.34314 2.34314C2.34292 2.34348 6.95655 8.00001 6.95655 8.00001L2.34314 13.6569Z",
  fill: "black"
}), React.createElement("path", {
  d: "M6.95658 8.00008L1.06108 4.01611C0.878301 4.33383 0.717113 4.66546 0.578613 5.00871L3.56327 8.00011L0.578707 10.9917C0.717082 11.3347 0.878113 11.6661 1.06077 11.9836L6.95658 8.00008Z",
  fill: "#FFDA44"
}), React.createElement("path", {
  d: "M15.9326 6.95654H6.95663L2.34338 2.34326C1.84625 2.84039 1.41435 3.40261 1.06135 4.01607L5.03757 8.00001L1.06104 11.9834C1.41404 12.5971 1.84613 13.1595 2.34338 13.6567L6.95663 9.04348H15.9326C15.9771 8.70192 16.0003 8.35367 16.0003 8.00001C16.0003 7.64636 15.9771 7.29811 15.9326 6.95654Z",
  fill: "#6DA544"
}), React.createElement("path", {
  d: "M3.12891 14.3462C4.47794 15.3832 6.16659 16.0001 7.99959 16.0001C11.6958 16.0001 14.806 13.4932 15.724 10.087H7.38812L3.12891 14.3462Z",
  fill: "#0052B4"
}), React.createElement("path", {
  d: "M15.724 5.91303C14.806 2.50691 11.6958 0 7.99959 0C6.16659 0 4.47794 0.616906 3.12891 1.65384L7.38809 5.91303H15.724Z",
  fill: "#D80027"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgSouthAfrica = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSouthAfrica, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/south-africa.7d77a2f6.svg";
export { ForwardRef as ReactComponent };